"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getFormatBatchItemStatus_1 = __importDefault(require("./getFormatBatchItemStatus"));
// 會把 setItems 也 format status
function formatBatchItemStatus(item) {
    return Object.assign(Object.assign({}, item), { setItems: item.setItems.map(setItem => formatBatchItemStatus(setItem)), status: getFormatBatchItemStatus_1.default(item) });
}
exports.default = formatBatchItemStatus;
//# sourceMappingURL=formatBatchItemStatus.js.map